



































































import Vue from 'vue';
import { Component, Ref } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { LoginInterface } from '@/modules/backend';
import { UserLoginData } from '@/modules/backend/Dto/UserLoginData';
import { Route } from 'vue-router';
import { ValidationObserver } from '@/plugins/vee-validate';
import ErrorAlerts from '@/components/errors/ErrorAlerts.vue';
import { ErrorsModule } from '@/store/app/errors/ErrorsModule';
import { resolveModule } from '@/store';

const AuthModule = namespace('app/auth');

@Component({
  components: {
    'error-alerts': ErrorAlerts
  }
})
export default class Login extends Vue {
  private readonly form: LoginInterface = {
    Password: '',
    Email: ''
  };

  private loading = false;

  @AuthModule.Action('Login')
  private readonly AuthLogin!: (payload: UserLoginData) => Promise<void>;

  private readonly errorsModule: ErrorsModule = resolveModule(ErrorsModule);

  @Ref('observer')
  private readonly observer!: ValidationObserver;

  private async GoToDashboard(): Promise<Route> {
    return await this.$router.push({ name: 'dashboard.events' });
  }

  private async Login(): Promise<void> {
    this.observer.reset();

    if (await this.observer.validate()) {
      this.loading = true;
      try {
        await this.AuthLogin({
          email: this.form.Email,
          password: this.form.Password
        });
        await this.errorsModule.clear();
      } catch (e) {
        /* Stop loading indicator and throw error to the error logger or so */
        this.loading = false;
        throw e;
      }

      await this.GoToDashboard();
    } else {
      throw new Error('Validation error');
    }
  }
}
